require('./jv.search.filters.directive.webpack');
require('./jv.search.filter-summary.directive');
require('../../common/directives/jv.pagination.directive');
require('./jv.search.grid.directive');
require('./jv.search.serializer.service');
require('./jv.search.type.service');
require('./jv.search.resume-view-modal.directive');
require('../../common/directives/expandy/jv.Expandy');
require('./jv.search.linkedin-profile-modal.directive');
require('../../common/jv.Debounce');
require('../jv.candidates.factory');
require('../jv.candidates.service');
require('./jv.search.config.service');
require('../../common/jv.Loading');
require('./jv.search.url-redirect.service.webpack');
require('./jv.search.filter-transforms.service');
require('../../common/jv.ga.service.webpack');
require('../../common/jv.object-util.service');

angular.module('jv.candidates.search.controller', [
    'ngRoute',
    'ngStorage',
    'jv.search.filters.directive',
    'jv.search.filter-summary.directive',
    'jv.common.pagination.directive',
    'jv.search.grid.directive',
    'jv.search.serializer.service',
    'jv.search.type.service',
    'jv.search.resume-view-modal.directive',
    'jv.Common.Directives.Expandy',
    'jv.search.linkedin-profile-modal.directive',
    'jv.Common.Debounce',
    'jv.candidates.list.factory',
    'jv.candidates.service',
    'jv.search.config.service',
    'jv.Common.Loading',
    'jv.search.url-redirect.service',
    'jv.search.filter-transforms.service',
    'jv.common.ga.service.js',
    'jv.object-util.service'
])
.factory('jvSearchParams', [function(){
    var notAllowedParams = ['login'];
    return function(currentParams){
        var allowedParams = {};
        angular.forEach(currentParams, function(value,key){
            var result = notAllowedParams.filter(function(item){ return item === key;});
            if(result.length === 0){
                allowedParams[key] = value;
            }
        });
        return allowedParams;
    };
}])
.controller('jvCandidatesSearchController', [
    // including $route to trigger $routeChangeSuccess (not using ng-view)
    '$scope', '$rootScope', 'jvSearchSerializer', '$location', 'debounce', '$routeParams', 'jvCandidatesListFactory', 'jvCandidatesService','$window', 'jvSearchConfigService', '$sessionStorage', '$timeout', 'Loading', 'jvSearchUrlRedirectService', 'getSearchTypes', '$q', 'filterTransforms', 'GAService', 'ObjectUtil', '$localStorage','jvHireBroadcastSVC','jvHireUrlService','jvSearchParams','TextUtil',
    function($scope, $rootScope, jvSearchSerializer, $location, debounce, $routeParams, jvCandidatesListFactory, jvCandidatesService, $window, jvSearchConfigService, $sessionStorage, $timeout, Loading, jvSearchUrlRedirectService, getSearchTypes, $q, filterTransforms, GAService, ObjectUtil, $localStorage, jvHireBroadcastSVC,jvHireUrlService,jvSearchParams,TextUtil) {
        var externalFilters = ['sortBy', 'order', 'keywords', 'page'];
        var loadedSearch = false;
        var minCharactersBeforeTypeAhead = 2;
        var delayBeforeTypeAheadFiredMs = 500;
        var lastKeywordSearch = {};
        var previousFilters;
        $sessionStorage.candAppList = $sessionStorage.candAppList || {};
        $scope.flags.loading = true;
        //jvUrls
        $scope.jvUrls = $window.jvUrls;
        $scope.properties = $window.properties;
        //flag to do validation for selected candidate
        var resetErrorMessages = function(){
            $scope.noCandidateSelected = false;
            $scope.reqsFromDifferentWorkflow = false;
            $scope.showDifferentWorkflowStatusMessage = false;
        };
        resetErrorMessages();
        $scope.candidateStickyColumnsAndHeadersEnabled = $window.candidateStickyColumnsAndHeadersEnabled;
        $scope.state = {
            filtersExpanded: true,
            selectedFilters: {},
            externalSelectedFilters: {},
            allStandardFilters: {},
            availableFilters: [],
            filterSummary: [],
            initialized: false,
            scrollEventAttachedToTable: false,
            selectAll: false,
            filterSummaryVisible: ($sessionStorage.candidateListFilterSummaryVisible != null) ? $sessionStorage.candidateListFilterSummaryVisible : true,
            searchTypes: {},

            showAutomationDetails: false,
            selectedAutomation: null,
            selectedAutomationId: null,
            tableData: [
                {
                    id: 1,
                    name: "Req is Closed (Dev)",
                    condition: "Department is Engineering",
                    action: "Set Disposition to Not Hired"
                },
                {
                    id: 2,
                    name: "Product Reqs",
                    condition: "Requisition Status changes and Candidate Activity is No Activity and Department is Design or Product.",
                    action: "Send email Candidate Rejected and Move to “Rejected” and set disposition to Not Hired"
                }
            ],
            typeAhead:{
                runAutomation: false,
                results:[],
                initialized:false,
                applyFilters: true,
                recentApplications: false,
                activeIndex: 0
            }
        };


        //RecentApplications stores a map of search type to searches(keyword or application)
        $scope.recentApplications = $localStorage.appSearchRecentApplications || {};

        //initialize search filters
        var initSearchFilters = function(){
            //pagination configs
            $scope.state.externalSelectedFilters.keywords = '';
            $scope.state.externalSelectedFilters.page = 0;
            $scope.state.externalSelectedFilters.sortBy = [{ fieldId: 'lastActivity' }];
            $scope.state.externalSelectedFilters.order = 'desc';
        };
        initSearchFilters();

        var setUpBulkActions = function(actions){
            //create custom
            var optionList = [];
            angular.forEach(actions,function(value,key){
                var optionObject = {};
                optionObject.value = value;
                optionObject.action = key;
                optionObject.id = key.toLowerCase();
                optionList.push(optionObject);
            });
            $scope.bulkActionsListConfig = {
                actionTitle: i18n.ACTIONS,
                sortOptions: optionList,
                selectedOption: -1
            };
        };

        //default view if list view for grid
        $scope.layout = {
            view: $sessionStorage.candAppList.layout || 'listView',
            wordWrap: $sessionStorage.candAppList.wordWrap !== undefined && $scope.candidateStickyColumnsAndHeadersEnabled ? $sessionStorage.candAppList.wordWrap : true
        };

        //cache results for all applications
        $scope.otherApplicationsMap = {};
        $scope.getOtherApplications = function(applicationEId, pageNumber, forceRefresh){
            var fetchOtherApplications = function(app){
                app.showLoader = true;
                var deferred = $q.defer();
                var args = {
                    applicationId: app.EId,
                    page: pageNumber,
                    maxResults: 5
                };
                //Make call to fetch candidate applications
                jvCandidatesService.getCandidateApplications(args,function(response){
                    if(response && response.data.applications && response.data.applications.length){
                        app.showLoader = false;
                        deferred.resolve(response.data.applications);
                    }
                });
                return deferred.promise;
            };

            var applicationsLength = $scope.applications.length;
            for(var i=0; i < applicationsLength ; i++){
                var appObj = $scope.applications[i];
                if(appObj.EId == applicationEId){
                    if(!$scope.otherApplicationsMap[appObj.EId] || forceRefresh){
                        fetchOtherApplications(appObj).then(function(otherApplications) {
                            $scope.otherApplicationsMap[appObj.EId] = otherApplications;
                            appObj.otherApplications = otherApplications;
                            appObj.showOtherApplications = true;
                        });
                    }else{
                        appObj.showOtherApplications = true;
                        appObj.otherApplications = $scope.otherApplicationsMap[appObj.EId];
                    }
                    break;
                }
            }
        };
        //performance optimization, fetching workflow indicators data, only for carded view
        var checkIfWorkflowIndicatorsDataRequired = function(applications){
            return applications.filter(function(application){
                return TextUtil.isNotNullOrUndefined(application.workflowIndicators);
            }).length === 0;
        };

        var setLayout = function(view){
            $scope.layout.view = view;
            if(view === 'cardedView' && checkIfWorkflowIndicatorsDataRequired($scope.applications)){
                 //set these flags to re-trigger search with updated filter
                $scope.state.selectedFilters.workflowIndicators = true;
                triggerParametrizedSavedSearchOnLoad(true);
            } else{
                delete $scope.state.selectedFilters.workflowIndicators;
                updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            }
            $sessionStorage.candAppList.layout = view;
        };

        $scope.toggleLayout = function(view){
            setLayout(view);
        };

        $scope.toggleWordWrap = function() {
            $scope.layout.wordWrap = !$scope.layout.wordWrap;
            $sessionStorage.candAppList.wordWrap = $scope.layout.wordWrap;
        };

        var processConfigData = function(data) {
            data.perms.isApplyConnectProfileEnabled = $window.isApplyConnectProfileEnabled;
            $sessionStorage.candSearchConfig = angular.copy(data);
            // TODO: remove when quickview column goes away
            // extra logic to put quickview column in correct order
            var nameColumn = data.columnHeaders.filter(function(column) {
                return column.searchId === 'fullName';
            }).pop();
            var infoColumn = data.columnHeaders.filter(function(column) {
                return column.searchId === 'info';
            }).pop();

            if (nameColumn && infoColumn) {
                infoColumn.displayOrder = nameColumn.displayOrder + 0.5;
            }

            $scope.state.columnHeaders = data.columnHeaders.sort(function(a, b) {
                return a.displayOrder - b.displayOrder;
            });

            if ($scope.candidateStickyColumnsAndHeadersEnabled) {
                $scope.state.columnHeaders[0].sticky = true; // Remove this if server-side `sticky` property is implemented.
            }

            $scope.state.availableFilters = data.standardSearchFilters.sort(function(a, b) {
                return a.displayOrder - b.displayOrder;
            });

            if (data.allStandardSearchFilters) {
                var notConfiguredFilters = data.allStandardSearchFilters.filter(function(allFilter) {
                    return !$scope.state.availableFilters.some(function(availableFilter) {
                        return allFilter.searchId === availableFilter.searchId;
                    });
                }).filter(function(notConfiguredFilter) {
                    notConfiguredFilter.hidden = true;
                    return notConfiguredFilter;
                });

                $scope.state.availableFilters = $scope.state.availableFilters.concat(notConfiguredFilters);
            }

            // make custom checkbox keys safe
            $scope.state.availableFilters.forEach(function(filter) {
                if (filter.filterType === 'CheckBox' && filter.values) {
                    filter.values = filter.values.map(function(value) {
                        return {
                            key: 'jv||' + value.key,
                            value: value.value
                        }
                    });
                }
            });

            $scope.state.allStandardFilters = data.allStandardSearchFilters;
            $scope.state.perms = data.perms;
            $scope.state.searchTypes = getSearchTypes(Object.keys(data.textSearchFilters));
            $scope.state.searchTypes.selectedOption = angular.isDefined($sessionStorage.candAppList.searchObject) ? $sessionStorage.candAppList.searchObject.order || 0 : 0;

            if(!$window.disableFlags){
                $window.disableFlags ={};
            }
            $window.disableFlags.skipWorkflow= data.perms.skipWorkflowState;

            $scope.activeSearchObject = $sessionStorage.candAppList.searchObject || {};
            $timeout(function(){
                $scope.activeSearchObject = $sessionStorage.candAppList.searchObject || $scope.state.searchTypes.sortOptions[0];
            },200);
            setUpBulkActions(data.actions);
        };

        var getConfigProcess;
        if ($sessionStorage.candSearchConfig && !$.isEmptyObject($sessionStorage.candSearchConfig) && angular.isDefined($sessionStorage.candSearchConfig.columnHeaders)) {
            processConfigData($sessionStorage.candSearchConfig);
            jvSearchConfigService.get().then(function(data) {
                if (!angular.equals(data, $sessionStorage.candSearchConfig)) {
                    processConfigData(data);
                }
            });
            getConfigProcess = (function() {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }());
            $timeout(function() {
                // wait for fonts, etc. to load
                $scope.state.initialized = false;
                $scope.flags.loading = true;
            });
        }
        else {
            getConfigProcess = jvSearchConfigService.get().then(processConfigData);
            Loading.queue(getConfigProcess.then(null, function() {
                $scope.$emit('showMessageBar', {
                    message: i18n['UNABLE_TO_PERFORM_OPERATION'],
                    type: 'error'
                });
            }));
        }

        //navigationListConfig for profile and search page links
        $scope.navigationListConfig = {
            actionTitle: i18n['SEARCH'],
            sortOptions: [
                {
                    value: i18n['APPLICATIONS'],
                    id: 0,
                    action: 'applications'
                }
            ],
            selectedOption: 0
        };
        if (properties.userHasRecruiterRole) {
            $scope.navigationListConfig.sortOptions.push({
                value: i18n['PROFILES'],
                id: 1,
                action: 'profiles'
            });
            if($window.isLinkedInUnifiedSearchEnabled) {
                $scope.navigationListConfig.sortOptions.push({
                    value: 'LinkedIn',
                    id: 2,
                    action: 'linkedIn'
                });
            }
        }

        //watch dropdown selection
        $scope.$watch('state.searchTypes.selectedOption', function(newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue != -1) {
                triggerSearchType($scope.state.searchTypes.sortOptions[newValue]);
            }
        });

        //watch dropdown selection
        $scope.$watch('navigationListConfig.selectedOption', function(newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue != -1) {
                triggerAction($scope.navigationListConfig.sortOptions[newValue].action);
            }
        });

        //watch dropdown selection
        $scope.$watch('bulkActionsListConfig.selectedOption', function(newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue != -1) {
                triggerBulkAction($scope.bulkActionsListConfig.sortOptions[newValue].action);
                $scope.bulkActionsListConfig.selectedOption = -1;
            }
        });

        //redirect to profile list page
        var goToProfileListPage = function(){
            var url = $scope.jvUrls.jhire +'/modules/candidates/list.html';
            $window.location.href = url;
        };

        //redirect to profile list page
        var goToLinkedInPage = function(){
            var url = $scope.jvUrls.jhire +'/modules/candidates/linkedin.html';
            $window.location.href = url;
        };

        //parentAppEId is the appEId of the application for which you open other apps list and select an app from that list
        $scope.triggerBulkAction = function(action, appEId, parentAppEId, reqEId, applicantName, isSingle, status){
            var isCardedView = true;
            triggerBulkAction(action, appEId, parentAppEId, reqEId, applicantName, isCardedView, isSingle, status);
        };
        //trigger navigation action dropdown
        var triggerAction = function(action){
            switch(action){
                case 'profiles':
                goToProfileListPage();
                break;
                case 'linkedIn':
                goToLinkedInPage();
                break;
            }
        };

        var triggerSearchType = function(searchObject){
            $scope.state.typeAhead.initialized = false;
            $scope.state.typeAhead.results =  $scope.recentApplications[searchObject.type];
            $scope.activeSearchObject = searchObject;
            $sessionStorage.candAppList.searchObject = angular.copy(searchObject);
            $scope.state.externalSelectedFilters.searchType = searchObject.type;
            if ($scope.activeSearchObject.type == 'name') {
                if (!loadedSearch) {
                    $scope.state.externalSelectedFilters.keywords = '';
                }
            }
            else if(typeAheadWatchSetup) {
                removeTypeAheadWatch();
            }
        };

        var setLastKeywordSearchFromFilter = function() {
            lastKeywordSearch = {
                keywords: $scope.state.externalSelectedFilters.keywords,
                type: $scope.activeSearchObject.type
            };
        };

        $scope.goToCandidateDetail = function(candidate){
            manageRecentApplications("name", null, candidate);
            $sessionStorage.search_index = candidatesFactory.getApplicationIds().indexOf(candidate.EId);
            $window.location.href = jvHireUrlService.getApplicationDetailsDefaultTabUrl(candidate.EId);
        };

        //hide type ahead dropdown
        $scope.hideTypeAheadDropdown = function(){
            $scope.state.typeAhead.initialized = false;
            $scope.state.typeAhead.activeIndex = 0;
            //Reset typeahead to show recent searches in the model.
            $scope.state.typeAhead.results =  $scope.recentApplications[$scope.activeSearchObject.type];
            $scope.state.typeAhead.recentApplications = false;
            $scope.state.canShowTypeaheadDropdown = false;
            removeTypeAheadWatch();
        };

        $scope.toggleTypeAheadFilters = function(){
            performTypeAheadSearch();
        };

        var performTypeAheadSearch = function(){
            $scope.state.typeAhead.initialized = true;
            //Hide the recent searches when type ahead search is triggered.
            $scope.state.typeAhead.recentApplications = false;
            $scope.state.externalSelectedFilters.page = 0;
            var removeCustomFilters = !$scope.state.typeAhead.applyFilters;
            $scope.getApplications(removeCustomFilters,true);
        };

        $scope.escapeKeyListener = function(){
            $scope.state.typeAhead.initialized = false;
        };

        $scope.arrowUpKeyListener = function(){
            (debounce(function(currentIndex) {
                $scope.state.typeAhead.activeIndex  = currentIndex - 1;
                    if($scope.state.typeAhead.activeIndex < 0){
                        $scope.state.typeAhead.activeIndex = 0;
                    }
            },100)($scope.state.typeAhead.activeIndex));
        };

        $scope.arrowDownKeyListener = function(){
            (debounce(function(currentIndex) {
                $scope.state.typeAhead.activeIndex  = currentIndex + 1;
                if($scope.state.typeAhead.activeIndex > $scope.state.typeAhead.results.length){
                    $scope.state.typeAhead.activeIndex = $scope.state.typeAhead.results.length;
                }
            },100)($scope.state.typeAhead.activeIndex));
        };

        /**
         * Called by recent search modal to clear recent search for the selected search type(name, resume etc)
         */
        $scope.clearRecentSearch = function() {
            if ($scope.recentApplications && $scope.recentApplications[$scope.activeSearchObject.type]) {
                delete $scope.recentApplications[$scope.activeSearchObject.type];
                $localStorage.recentApplications = $scope.recentApplications;
            }
            $scope.state.typeAhead.clearModal = false;
        }

        /**
         * Method to trigger search. Used in various ways. It can be used for typeahead, keyword search and recent search(keyword or application)
         * @param  type  What kind of search type("name", "note" etc)
         * @param  value If the search is triggered from
         */
        $scope.submitSearch = function(type, value) {
            if (value) {
                $scope.state.externalSelectedFilters.keywords = value;
            }

            //Value was sent from the template for the recent search selected.
            if($scope.state.typeAhead.activeIndex === 0){
                submitSearchKeywordSearch();
                $scope.hideTypeAheadDropdown();
                return;
            }

            var app = null;
            var storedResult = $scope.state.typeAhead.results[$scope.state.typeAhead.activeIndex-1];

            //If the selected application is from typeahead or is of recent type "application" and not keyword, then land on candidate details page.
            if (storedResult.recent) {
                if (storedResult.type ==='application') {
                    app = storedResult.value;
                } else {
                    $scope.state.externalSelectedFilters.keywords = storedResult.value;
                }
            } else {
                app = storedResult;
            }

            if (app) {
                $scope.goToCandidateDetail(app);
                return;
            } else {
                submitSearchKeywordSearch();
            }

            $scope.hideTypeAheadDropdown();
        }

        var submitSearchKeywordSearch = function() {
            $scope.state.externalSelectedFilters.page = 0;
            $scope.state.typeAhead.initialized = false;
            $scope.state.externalSelectedFilters.sortBy = null;
            updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            setLastKeywordSearchFromFilter();
            $scope.getApplications();
            GAService.track('Application Search; Type=' + $scope.state.externalSelectedFilters.searchType);
        };

        var destroyTypeahead;
        var typeAheadWatchSetup = false;

        var removeTypeAheadWatch = function() {
            if (destroyTypeahead) {
                destroyTypeahead();
            }
            typeAheadWatchSetup = false;
        }

        var checkIfEnoughCharForTypeAhead = function(keyword) {
            if (keyword && keyword.length >= minCharactersBeforeTypeAhead) {
                return true;
            } else {
                return false;
            }
        }

        var setUpTypeAhead = function() {
            destroyTypeahead = $scope.$watch('state.externalSelectedFilters.keywords', debounce(function(keyword) {
                typeAheadWatchSetup = true;
                if (checkIfEnoughCharForTypeAhead(keyword)  && $scope.activeSearchObject.type == 'name' && $scope.state.canShowTypeaheadDropdown) {
                    performTypeAheadSearch();
                } else if (keyword != null && keyword.length == 0) {
                    $scope.state.typeAhead.activeIndex = 0;
                    $scope.hideTypeAheadDropdown();
                }
            }, delayBeforeTypeAheadFiredMs), true); //deep watch
            $scope.state.typeAhead.activeIndex = 0 ;
        };
        //trigger dropdownaction
        var triggerBulkAction = function(action, appEId, parentAppEId, reqEId, applicantName, cardedView, isSingle, status){
            //This is to avoid executing the code related to JV.Person in the bulk action controllers.
            JV.Person = null;
            $scope.reqsFromDifferentWorkflow = false;
            $scope.showDifferentWorkflowStatusMessage = false;
            $scope.validationError = false;
            $scope.noCandidateSelected = false;
            $scope.notFilteredConsentState = false;
            var data = {
                appIds: []
            };
            if(cardedView){
                //$scope.selectedResults[appEId] = true;
                data.appIds = [appEId];
                data.name = applicantName;
                data.reqId = reqEId;
            }else{
                data.appIds = candidatesFactory.getSelectedCandidates('EId');
            }
            if(!data.appIds.length){
                $scope.noCandidateSelected = true;
                return;
            }
            var candidates = [];
            if(isSingle){
                angular.forEach($scope.applications,function(appObj){
                    if(appObj.EId === appEId){
                        candidates.push(appObj);
                    }
                });
            }else{
                candidates = candidatesFactory.getSelectedCandidates();
            }

            // reset previous filters so grid can be refreshed
            previousFilters = null;

            //validate if applications are of the same req
            var validateReqs = function(){
                var reqEId = candidates[0].jobEId;
                $scope.reqsFromDifferentWorkflow = false;
                angular.forEach(candidates,function(item,key){
                    if(item.jobEId !== reqEId){
                        $scope.reqsFromDifferentWorkflow = true;
                        $scope.flags.loading = false;
                        $scope.validationError = true;
                    }
                });

                if(!$scope.reqsFromDifferentWorkflow && $scope.state.selectedFilters.jobs && $scope.state.selectedFilters.jobs.reqEId){
                    data.reqId = $scope.state.selectedFilters.jobs.reqEId;
                }
            };

            //validate if applications are having same status
            var validateCandidateStatus = function(){
            $scope.showDifferentWorkflowStatusMessage = false;
            if(!$window.disableFlags.skipWorkflow){
                var candidateStateTitle = candidates[0].candidateState.title;
                angular.forEach(candidates,function(item,key){
                    if(item.candidateState.title !== candidateStateTitle){
                        $scope.showDifferentWorkflowStatusMessage = true;
                        $scope.flags.loading = false;
                        $scope.validationError = true;
                    }
                });
              }
            };

             var rejectModalSucess = function(event, onlyReset, multiple){
                if(onlyReset){
                    return;
                }
                $scope.$emit('showMessageBar', i18n[multiple ? 'REJECT_SUCCESSFUL_MULTIPLE' : 'REJECT_SUCCESSFUL_SINGLE']);
                $scope.getApplications();
            };
            var rejectMoveCandidate = function(event, onlyReset, multiple){
                if(onlyReset){
                    return;
                }
                $scope.$emit('showMessageBar', i18n.REJECT_MOVE_MODAL);
                $scope.getApplications();
            }
            if(candidates.length ===1){
                data.name = candidates[0].fullName;
            }
            switch(action){
                case 'ADD_TO_COLLECTION':
                //add to collection
                $rootScope.$broadcast('showAddToCollectionModal', data);
                jvHireBroadcastSVC.subscribe('showAddToCollectionResult',function(event,data){
                    if(data){
                        $scope.$emit('showMessageBar', i18n.ADDED_TO_COLLECTION);
                        $scope.getApplications();
                    }
                });
                break;

                case 'CHANGE_STATUS':
                //change status
                if (status) {
                    data.name = status;
                    data.skipModalView = true;
                }
                if(candidates.length>1){
                    validateReqs();
                    validateCandidateStatus();
                }
                if(!$scope.reqsFromDifferentWorkflow && !$scope.showDifferentWorkflowStatusMessage){
                    if (candidates[0]) {
                        if (candidates[0].jobEId){
                            data.reqId = candidates[0].jobEId;
                        }
                        data.displayCurrentStatus = candidates[0].candidateState.EId;
                        if(!$window.disableFlags.skipWorkflow){
                            data.currentStatus= candidates[0].candidateState.title;
                        }
                    }

                    $rootScope.$broadcast('showChangeStatusModal', data);
                    $rootScope.$on('showChangeStatusResult',function(event,data){
                        if(data){
                            $scope.flags.loading = false;
                            $scope.$emit('showMessageBar', i18n.CANDIDATE_STATUS_UPDATED);
                            $scope.getApplications();
                        }
                    });
                }

                break;

                case 'SUBMIT_HM_MODAL_CLICKED':
                data.jobEId = reqEId;
                data.stateId = status;
                $rootScope.$broadcast('showsubmitToHMModal', data);
                break;

                case 'OFFER_REJECTED_CLICKED':
                    data.stateId = status;
                    $rootScope.$broadcast('showOfferRejectModal', data);

                    $rootScope.$on('showOfferRejectModalSuccess',function(event){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n.CANDIDATE_STATUS_UPDATED);
                        $scope.getApplications();
                    });

                    break;

                case 'DELETE':
                //delete candidate

                $rootScope.$broadcast('showDeleteCandidateModal', data);
                $rootScope.$on('ANONYMIZE_SUCCESSFUL',function(event){
                    $scope.flags.loading = false;
                    $scope.$emit('showMessageBar', i18n['CANDIDATES_ANNONYMIZED']);
                    if(parentAppEId){
                        $scope.getOtherApplications(parentAppEId,true);
                    }else{
                        $scope.getApplications();
                    }
                });
                $rootScope.$on('DELETE_SUCCESSFUL_MULTIPLE',function(event){
                    $scope.flags.loading = false;
                    $scope.$emit('showMessageBar', i18n['CANDIDATES_DELETED_SUCCESSFULLY']);
                    if(parentAppEId){
                        $scope.getOtherApplications(parentAppEId,true);
                    }else{
                        $scope.getApplications();
                    }
                });
                break;

                case 'MOVE_CANDIDATE':
                if(candidates.length>1 && $scope.properties.enableMoveCandidate === false){
                    validateReqs();
                }
                if(!$scope.reqsFromDifferentWorkflow){
                    if(candidates[0] && candidates[0].jobEId){
                        data.reqId = candidates[0].jobEId;
                    }

                    //move candidate modal
                    $rootScope.$emit('showMoveCandidateModal', data);
                    $rootScope.$on('MOVE_SINGLE_CANDIDATE_SUCCESS',function(event,data){
                        $scope.$emit('showMessageBar', i18n['MOVE_CANDIDATE_SINGLE']);
                        if(parentAppEId){
                            $scope.getOtherApplications(parentAppEId,true);
                        }else{
                            $scope.getApplications();
                        }
                    });
                    $rootScope.$on('MOVE_MULTIPLE_CANDIDATE_SUCCESS',function(event,data){
                        $scope.$emit('showMessageBar', i18n['MOVE_CANDIDATE_MULTIPLE'].format(data.length));
                        $scope.getApplications();
                    });
                    $rootScope.$on('rejectCandidateSuccess', rejectMoveCandidate);
                }
                break;

                case 'SEND_MESSAGE':
                //send message
                $rootScope.$emit('showSendMessageModal', data);
                $rootScope.$on('sendMessageSuccess',function(event,data){
                    if(data){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n.MESSAGE_SENT);
                        $scope.getApplications();
                    }
                });
                break;

                case 'INVITATION_TO_SELF_SCHEDULE':
                //Bulk CSS -----TEST 4
                if(candidates.length>1){
                    validateReqs();
                    validateCandidateStatus();
                }
                if(!$scope.reqsFromDifferentWorkflow && !$scope.showDifferentWorkflowStatusMessage){
                    if (candidates[0]) {
                        if (candidates[0].jobEId){
                            data.reqId = candidates[0].jobEId;
                        }
                        data.displayCurrentStatus = candidates[0].candidateState.EId;
                        if(!$window.disableFlags.skipWorkflow){
                            data.currentStatus= candidates[0].candidateState.title;
                        }
                    }

                     $rootScope.$emit('showBulkCSSModal', data);
                    //$scope.getApplications();
                    $rootScope.$on('sendMessageSuccess',function(event,data){
                        if(data){
                            $scope.flags.loading = false;
                            $scope.$emit('showMessageBar', i18n.MESSAGE_SENT);
                            $scope.getApplications();
                        }
                    });
                }

//                $rootScope.$emit('showBulkCSSModal', data);
//                //$scope.getApplications();
//                $rootScope.$on('sendMessageSuccess',function(event,data){
//                    if(data){
//                        $scope.flags.loading = false;
//                        $scope.$emit('showMessageBar', i18n.MESSAGE_SENT);
//                        $scope.getApplications();
//                    }
//                });
                break;

                case 'SEND_SMS_MESSAGE':
                    $rootScope.$emit('showSendSMSMessageModal', data);
                    $rootScope.$on('sendSMSMessageSuccess',function(event,data){
                    if(data){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n.MESSAGE_SENT);
                        $scope.getApplications();
                    }
                });
                break;

                case 'SEEK_CONSENT':
                //seek consent
                $scope.notFilteredConsentState = false;
                $rootScope.$emit('showSeekConsentModal', data);
                $rootScope.$on('sendMessageSuccess',function(event,data){
                    if(data){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n.MESSAGE_SENT);
                        $scope.getApplications();
                    }
                });
                break;

                case 'SEND_NOTE':
                //send note
                $rootScope.$emit('showSendNoteModal', data);
                $rootScope.$on('showSendNoteResult',function(event,data){
                    if(data){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n['SEND_NOTE_SUCCESS']);
                        $scope.getApplications();
                    }
                });
                break;

                case 'SEND_VIDEO_INTERVIEW':
                //send video
                $rootScope.$broadcast('showVideoModalAdHoc', data);
                $rootScope.$on('showVideoModalResult', function(event,data){
                    if(data){
                        $scope.flags.loading = false;
                        $scope.$emit('showMessageBar', i18n['JV_APPLICANT_INVITE_SENT']);
                        $scope.getApplications();
                    }
                });
                break;

                case 'ADD_TO_REQUISITION':
                    $rootScope.$emit('showAddToReqModal',data);
                    //show notification for candidate added to requisition
                    $rootScope.$on('CandidateAddedToReq',function(event){
                        $scope.flags.loading = false;
                        if(candidates.length>1){
                            $scope.$emit('showMessageBar', i18n['CANDIDATES_ADDED_MULTIPLE']);
                        }else{
                            $scope.$emit('showMessageBar', i18n['CANDIDATES_ADDED_SINGLE']);
                        }
                        $scope.getApplications();
                        if(parentAppEId){
                            $scope.getOtherApplications(parentAppEId,true);
                        }else{
                            $scope.getApplications();
                        }
                    });

                break;

                case 'DOWNLOAD_RESUMES':
                    var bulk = true;
                    $rootScope.$broadcast('showBulkResumeDownloadModal', bulk, data);
                break;

                case 'REJECT':
                var bulk = true;
                data.appId = data.appIds;
                data.moveCandidateEnabled = true;
                $rootScope.$broadcast('showRejectCandidateModal', bulk, data);
                $rootScope.$on('rejectCandidateSuccess', rejectModalSucess)
                break;
                default:
            }
        };

        //create candidate factory instance
        var candidatesFactory = new jvCandidatesListFactory();

        //callbaks to fire after application List data is updated/fetched
        var updateTotalCount = function(){
            if(!$scope.state.typeAhead.initialized){
                $scope.totalCount = candidatesFactory.totalCount;
            }

        };

        var updateApplicationsMap = function(){
            $scope.ApplicationsMap = candidatesFactory.applicationsMap;
        };

        var resetSelectAll = function(){
            $scope.state.selectedCandidates = candidatesFactory.resetselectedCandidate();
        };

        var getPageSize = function(){
            if(!$scope.state.typeAhead.initialized){
                $scope.pageSize = candidatesFactory.getPageSize();
            }

        };

        var updateCurrentPage = function() {
            candidatesFactory.updateCurrentPage($scope.state.externalSelectedFilters.page);
        };

        //register subscribers/callbacks to fire after candidatelist gets updates
        candidatesFactory.registerApplicationsSubscribers([updateTotalCount,updateApplicationsMap,resetSelectAll,getPageSize,updateCurrentPage]);

        //build candidate search filter
        var getApplicationSearchFilter = function(removeCustomFilters, typeAheadSearch){
             //fetch type from activesearchobject
            var type = lastKeywordSearch.type;

            //if type is stored in locastorage fetch from locastorage
            if($sessionStorage.candAppList.searchObject && $sessionStorage.candAppList.searchObject.type){
                type = $sessionStorage.candAppList.searchObject.type;
            }
            if($scope.layout.view === 'cardedView'){
                $scope.state.selectedFilters.workflowIndicators = true;
            }
            var filter = {
                keywordSearch: {
                    keyword: (typeAheadSearch) ? $scope.state.externalSelectedFilters.keywords : lastKeywordSearch.keywords,
                    searchNameOnly: (type === 'name'),
                    searchNotesOnly: (type === 'note'),
                    searchMessagesOnly: (type === 'message'),
                    searchResumeOnly: (type === 'resume'),
                    exactMatch: (type === 'exactMatch'),
                    typeAhead: typeAheadSearch || false
                }
            };

            if (typeAheadSearch) {
                filter.maxResults = 10;
            }
            if (!removeCustomFilters) {
                angular.extend(filter, filterTransforms($scope.state.availableFilters, $scope.state.selectedFilters, $scope.state.externalSelectedFilters, $scope.state.allStandardFilters))
            }
            if (!filter.page) {
                filter.page = 0;
            }

            return ObjectUtil.removeNullProps(filter);
        };

        var isSearchEmpty = function(filters, externalFilters) {
            if (!filters) {
                filters = $scope.state.selectedFilters;
            }
            if (!externalFilters) {
                externalFilters = $scope.state.externalSelectedFilters;
            }
            if (!filters) {
                return true;
            }
            if (externalFilters.keywords) {
                return false;
            }
            if (externalFilters.page > 0) {
                return false;
            }
            return $scope.state.filtersEmpty;
        };

        var updateSerializedSearch = function(filters, externalFilters) {
            var params = angular.extend({}, filters, externalFilters);
            var serializedParams = jvSearchSerializer.serialize(params);
            if (serializedParams !== $routeParams.query && angular.isUndefined($routeParams.applicationId)) {
                 $scope.state.serializedParams = serializedParams;
                 $location.path('/q/' + serializedParams, false).search('').replace();
            }
        };

        $rootScope.$on('refreshCandidateSearhGrid',function(event,data){
            if(data){
                $scope.getApplications();
            }
        });

        var manageRecentApplications = function(searchType, keywords, application) {
            var recentObject = {
                recent: 'true'
            };
            var existingOption = false;
            var addObject = false;
            $scope.recentApplications[searchType] = $scope.recentApplications[searchType] || [];

            if (searchType === 'name') {
                if (application) {
                    addObject = true;
                    recentObject.type = 'application';
                    recentObject.value = application;

                    existingOption = $scope.recentApplications[searchType].filter(function(option) {
                        return (option.type === 'application' && option.value && option.value.EId === application.EId);
                    }).pop();
                }
            }
            if (!application && keywords) {
                addObject = true;
                recentObject.type = 'keyword';
                recentObject.value = keywords;

                existingOption = $scope.recentApplications[searchType].filter(function(option) {
                    return (option.type === 'keyword' && option.value === keywords);
                }).pop();
            }
            //Only add if existing option.
            if (!existingOption && addObject) {
                $scope.recentApplications[searchType].unshift(recentObject);
                if ($scope.recentApplications[searchType].length > 10) {
                    // limit to 10 most recent per searchType
                    $scope.recentApplications[searchType].pop();
                }
                $scope.state.typeAhead.results = $scope.recentApplications[searchType];
                $localStorage.appSearchRecentApplications = $scope.recentApplications;
            }
        };

        $scope.getAnonymizedAppCount = function(){
            var filters = angular.copy($sessionStorage.appSearchFilters);
            filters.anonymized = true;
            candidatesFactory.getApplicationsCount(filters, function(response){
                $scope.anonymousCount = response.totalCount;
            });
        };

        //call for candidates
        $scope.getApplications = function(removeCustomFilters, typeAheadSearch){
            //reset select all
            $scope.state.selectAll = false;
            resetErrorMessages();

            var filters = getApplicationSearchFilter(removeCustomFilters, typeAheadSearch);

            if (!typeAheadSearch && filters.keywords) {
                manageRecentApplications(filters.searchType, filters.keywords);
            }

            if (!typeAheadSearch) {
                if (previousFilters && angular.equals(previousFilters, filters)) {
                    return $timeout(angular.noop);
                }

                previousFilters = filters;
            }

            // remove any existing searches for candidate list pagination.
            delete $sessionStorage.search_guid;
            delete $sessionStorage.search_page;

            //For Application List Pagination
            delete $sessionStorage.search_index;
            delete $sessionStorage.search_total_count;
            delete $sessionStorage.search_application_ids;
            sessionStorage.removeItem('reqsId');
            // set new search
            $timeout(function() {
                $sessionStorage.appSearchFilters = filters;
                $sessionStorage.appSearchSerializedFilters = $scope.state.serializedParams;
            });

            var process = candidatesFactory.getApplications(filters);
            Loading.queue(process.then(function(response) {
                $scope.state.initialized = true;
                $scope.flags.loading = false;
                if (!typeAheadSearch) {
                    $scope.searchedKeywords = filters.keywordSearch.keyword;
                }
                if ($scope.state.typeAhead.initialized) {
                    $scope.state.typeAhead.activeIndex = 0;
                    $scope.state.typeAhead.results = candidatesFactory.getApplicationsList();
                }
                else {
                    $scope.applications = candidatesFactory.getApplicationsList();
                    //Passing the applicationIds from the list to the details page, so that details page does not have to fire the search again.
                    //Currently, the way we are doing pagination, breaks multi-tab browsing. We will need to fix it.
                    $sessionStorage.search_application_ids =  candidatesFactory.getApplicationIds();
                    $sessionStorage.search_total_count = candidatesFactory.totalCount;
                }
                const tableElement = document.querySelector('.applicationsList .grid-data.sticky');
                if (tableElement && !$scope.state.scrollEventAttachedToTable) {
                    tableElement.addEventListener('scroll', function() {
                        tableElement.classList.toggle('show-sticky-column-shadow', !!tableElement.scrollLeft);
                    });
                    $scope.state.scrollEventAttachedToTable = true;
                }
            }));
            return process;
        };

        var triggerRecentApplications = function() {
            $scope.state.typeAhead.recentApplications = true;
            $scope.state.typeAhead.results =  $scope.recentApplications[$scope.activeSearchObject.type];
        };

        $scope.$watch('state.canShowTypeaheadDropdown', function(newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                triggerRecentApplications();
            }
        });

        $scope.showTypeAheadSearch = function() {
            return ($scope.state.externalSelectedFilters.keywords && $scope.state.typeAhead.initialized);
        };

        $scope.showRecentAppSearch = function() {
            return (!checkIfEnoughCharForTypeAhead($scope.state.externalSelectedFilters.keywords) && $scope.state.typeAhead.recentApplications && $scope.state.typeAhead.results && $scope.state.typeAhead.results.length);
        };

        $scope.initializeData = function() {
            if ($scope.state.externalSelectedFilters.keywords) {
                $scope.state.canShowTypeaheadDropdown = true;
                if (!typeAheadWatchSetup) {
                    setUpTypeAhead();
                }
            } else {
                $scope.state.canShowTypeaheadDropdown = true;
            }
        };

        $scope.nextPage = function() {
            $scope.state.externalSelectedFilters.page++;
            updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            return $scope.getApplications();
        };

        $scope.previousPage = function() {
            $scope.state.externalSelectedFilters.page--;
            updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            return $scope.getApplications();
        };

        $scope.resetGrid = function() {
            loadedSearch = false;
            initSearchFilters();
            triggerSearchType($sessionStorage.candAppList.searchObject || $scope.state.searchTypes.sortOptions[0]);
            $scope.state.searchTypes.selectedOption = $sessionStorage.candAppList.searchObject.order || 0;
            $scope.state.selectAll = false;
            $scope.toggleFilterSummary(true);
            $scope.state.availableFilters.forEach(function(filter) {
                filter.collapsed = false;
            });
            $scope.state.typeAhead = {
                results: [],
                initialized: false,
                applyFilters: true,
                recentApplications: false,
                activeIndex: 0
            };
            lastKeywordSearch = {};
        };

        $scope.resume = {
            view: function(application) {
                $scope.state.viewResume = true;
                $scope.resume.application = application;
                $scope.resume.index = $scope.applications.indexOf(application);
            },
            hide: function() {
                $scope.state.viewResume = false;
            },
            hasNext: function() {
                if ($scope.applications) {
                    return ($scope.resume.index < $scope.applications.length - 1 || ($scope.state.externalSelectedFilters.page * $scope.pageSize) + $scope.pageSize < $scope.totalCount);
                }
                return false;
            },
            hasPrevious: function() {
                if ($scope.applications) {
                    return ($scope.resume.index > 0 || $scope.state.externalSelectedFilters.page > 0);
                }
                return false;
            },
            candidateUrl: function(application) {
                return jvHireUrlService.getApplicationDetailsDefaultTabUrl(application.EId);
            },
            requisitionUrl: function(application) {
                var url = jvUrls.jhire + '/modules/requisitions/tabs.html?#/summary/' + application.jobEId;
                return url;
            },
            onNext: function() {
                if ($scope.resume.index < $scope.applications.length -1) {
                    $scope.resume.index += 1;
                    $scope.resume.application = $scope.applications[$scope.resume.index];
                }
                else {
                    return $scope.nextPage().then(function() {
                        $scope.resume.index = 0;
                        $scope.resume.application = $scope.applications[$scope.resume.index];
                    });
                }
            },
            onPrevious: function() {
                if ($scope.resume.index > 0) {
                    $scope.resume.index -= 1;
                    $scope.resume.application = $scope.applications[$scope.resume.index];
                }
                else {
                    return $scope.previousPage().then(function() {
                        $scope.resume.index = $scope.applications.length - 1;
                        $scope.resume.application = $scope.applications[$scope.resume.index];
                    });
                }
            }
        };

        $scope.sort = function(fieldId) {
            var sortBy = $scope.state.externalSelectedFilters.sortBy;
            if (sortBy && sortBy[0] && sortBy[0].fieldId === fieldId) {
                $scope.state.externalSelectedFilters.order = ($scope.state.externalSelectedFilters.order === 'asc') ? 'desc' : 'asc';
            }
            else {
                $scope.state.externalSelectedFilters.sortBy = [{ fieldId: fieldId }];
                $scope.state.externalSelectedFilters.order = 'desc';
            }
            updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            $scope.getApplications();
        };

        //watch selectall checkbox to toggle all rows
        $scope.$watch('state.selectAll',function(newVal,oldVal){
            if(newVal){
                //toggle all rows if select all checkbox selected
                $scope.state.selectedCandidates = candidatesFactory.selectAllCandidates();
            }else{
                //object to hold checkbox selection for each row
                $scope.state.selectedCandidates = candidatesFactory.resetselectedCandidate();
            }
        });

        $scope.toggleFilterSummary = function(visible) {
            if (visible != null) {
                $scope.state.filterSummaryVisible = visible;
            }
            else {
                $scope.state.filterSummaryVisible = !$scope.state.filterSummaryVisible;
            }
            $sessionStorage.candidateListFilterSummaryVisible = $scope.state.filterSummaryVisible;
        };

        $scope.loadSavedSearch = function(search) {
            var params = jvSearchSerializer.deserialize(search) || {};
            var index = 0;
            // bypass watch debounce delay
            loadedSearch = true;
            $scope.state.canShowTypeaheadDropdown = false;
            externalFilters.forEach(function(filter) {
                if (params[filter]) {
                    $scope.state.externalSelectedFilters[filter] = params[filter];
                    delete params[filter];
                }
                else {
                    $scope.state.externalSelectedFilters[filter] = null;
                }
            });

            if ($scope.state.externalSelectedFilters.page == null) {
                $scope.state.externalSelectedFilters.page = 0;
            }

            //HIRE-13075: Always default to sorting by lastActivity descending if the parameters are not passed.
            if ($scope.state.externalSelectedFilters.order == null) {
                $scope.state.externalSelectedFilters.order = 'desc';
            }

            //Sort by should not be set for keyword search. For every other case, we should default to lastActivity. We should not have
            //scenario when search is performed and sortBy is not set.
            if ($scope.state.externalSelectedFilters.sortBy == null && ($scope.state.externalSelectedFilters.keywords == null || angular.isUndefined($scope.state.externalSelectedFilters.keywords))) {
                $scope.state.externalSelectedFilters.sortBy = [{ fieldId: 'lastActivity' }];
            }

            // unique case for search type (doesn't use ng-model)
            if (params.searchType != null) {
                $scope.state.searchTypes.sortOptions.forEach(function(option, i) {
                    if (option.type === params.searchType) {
                        index = i;
                    }
                });
                triggerSearchType($scope.state.searchTypes.sortOptions[index]);
                $scope.state.searchTypes.selectedOption = index;
                delete params.searchType;
            }
            else {
                triggerSearchType($sessionStorage.candAppList.searchObject || $scope.state.searchTypes.sortOptions[0]);
                $scope.state.searchTypes.selectedOption = $sessionStorage.candAppList.searchObject.order || 0;
            }

            // backwards compat for old checkbox filter
            $scope.state.availableFilters.forEach(function(filter) {
                var newCheckboxValues = {};
                if (params[filter.searchId] && filter.filterType === 'CheckBox') {
                    Object.keys(params[filter.searchId]).forEach(function(key) {
                        if (key.substr(0, 4) !== 'jv||') {
                            newCheckboxValues['jv||' + key] = params[filter.searchId][key];
                        }
                        else {
                            newCheckboxValues[key] = params[filter.searchId][key];
                        }
                    });
                    params[filter.searchId] = newCheckboxValues;
                }
            });

            if (params.workflowStateId && !Array.isArray(params.workflowStateId)) {
                params.workflowStateId = [params.workflowStateId];
            }

            $scope.state.selectedFilters = params;
            updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
            setLastKeywordSearchFromFilter();

            // workaround for old source filter, filter directive will update it
            // need to return here so the watch will pick up the change
            if (typeof params.sourceId === 'string') {
                loadedSearch = false;
            }

            $scope.getApplications();
        };

        //This is requird to trigger search by saved filters
        var loadSavedSearchOnInit = false, resetFilters = false, ignoreFilterChange =  false;
        var triggerParametrizedSavedSearchOnLoad = function(forceReload){
            if(forceReload){
                resetFilters = true;
                ignoreFilterChange = false;
            }
            if (!loadSavedSearchOnInit) {
                loadSavedSearchOnInit = true;
                loadedSearch = true;
                if(!$.isEmptyObject(jvSearchParams($scope.params))){
                    if($scope.params.query){
                        if ($scope.params.query === 'return') {
                            $scope.state.serializedParams = $sessionStorage.appSearchSerializedFilters;
                        }
                        else {
                            $scope.state.serializedParams = $scope.params.query;
                        }
                        //flag shouldn't be set in case of an empty search as no further watches triggered
                        //in this case on first time load.
                        if(!$rootScope.emptySearch){
                            ignoreFilterChange = true
                        }
                        getConfigProcess.then(function() {
                            $scope.loadSavedSearch($scope.state.serializedParams);
                        });
                    } else {
                        // start listening only for top nav searches
                        var searchTerm = location.hash.split('#/?q=')[1];
                        if (searchTerm) {
                            $scope.state.searchTypes.selectedOption = 4;
                        }
                        performQueryParamSearch($scope);
                    }
                }else{
                    resetFilters = true;
                    getConfigProcess.then(function() {
                        $scope.$broadcast('resetFilter');
                    });
                }
            } else if(resetFilters && !ignoreFilterChange){
                resetFilters = false;
                $scope.state.externalSelectedFilters.page = forceReload ? $scope.state.externalSelectedFilters.page : 0;
                updateSerializedSearch($scope.state.selectedFilters, $scope.state.externalSelectedFilters);
                $scope.getApplications();
            } else{
                ignoreFilterChange = false;
            }
        };

        var performQueryParamSearch = function(currentRoute){
            // check for query params
            loadedSearch = true;
            jvSearchUrlRedirectService.setFromParams(currentRoute.params);
            getConfigProcess.then(function() {
                $scope.state.serializedParams = jvSearchUrlRedirectService.getEncodedData();
                $scope.loadSavedSearch($scope.state.serializedParams);
            });
        };

        var triggerSearchByFilterChange = (function(newVal, oldVal) {
            resetFilters = resetFilters || JSON.stringify(newVal) !== JSON.stringify(oldVal);
            triggerParametrizedSavedSearchOnLoad();
            $rootScope.emptySearch = $scope.state.filtersEmpty;
        });

        $scope.$on('filtersLoaded', function() {
            $scope.$watch('state.filterSummary', debounce(triggerSearchByFilterChange, 300), true); //deep watch
        });

        jvHireBroadcastSVC.subscribe('ignoreFilterChange',function(){
            ignoreFilterChange = true;
        });

        $scope.$on('$destroy', function(){
            jvHireBroadcastSVC.destroyAll();
        });

        $scope.toggleModalAndDetails = function() {
            if($scope.state.showAutomationDetails) {
                $scope.state.showAutomationDetails = false;
            } else {
                $scope.state.typeAhead.runAutomation = false;
            }
        };

        $scope.toggleDetails = function() {
            if($scope.state.showAutomationDetails) {
                runAutomation();
            } else {
                $scope.state.showAutomationDetails = true;
            }
        };

        

        $scope.selectAutomation = function(id) {
            $scope.state.selectedAutomation = $scope.state.tableData.find(function(data) {
                return data.id === id;
            });
        };

        function runAutomation() {
            $scope.state.typeAhead.runAutomation = false;
            // Code to run the automation goes here
        };

        if ($scope.candidateStickyColumnsAndHeadersEnabled) {
            $(window).on('resize', function() {
                const prevValue = $scope.state.filtersExpanded;
                $scope.state.filtersExpanded = window.document.body.clientWidth > 1024;
                if ($scope.state.filtersExpanded !== prevValue) {
                    $scope.$digest();
                }
            });
        }
    }
]);
